export { useAssignedAdminQuery } from './useAssignedAdminQuery';
